import { defaultDifficulty } from './constants'
import { getTodayNumber } from './functions'
import { clamp } from 'lodash'
import { globalOnDemandVars } from '../helper/context'

const FAIL = 0
// const HARD = 0.6
// const NORMAL = 8 / 9
// const EASY = 10 / 9

export function getRatingAsNumber (rating) {
  const values = globalOnDemandVars.algorithmConstants()

  switch (rating) {
    case 'fail':
      return FAIL
    case 'hard':
      return values.hardValue
    case 'normal':
      return values.normalValue
    case 'easy':
      return values.easyValue
  }
}

export function getPercentOverdue (record, today) {
  const calculated = (today - record.update) / record.interval
  // 원래 최소값은 2 였음
  return Math.min(2, calculated)
}

export function getNewRecord (record, performanceRating, plusDayForTest) {
  const today = getTodayNumber(true) + (plusDayForTest || 0)
  const percentOverDue = getPercentOverdue(record, today)

  const difficulty = clamp(record.difficulty + (((8 - 9 * performanceRating) / 17) * percentOverDue), 0, 1)
  const difficultyWeight = 3 - (1.7 * difficulty)
  let interval = record.interval
  if (performanceRating === FAIL) {
    interval = Math.round(Math.max(1, interval * (1 / difficultyWeight / difficultyWeight)))
  } else {
    // interval = 1 + Math.round((difficultyWeight - 1) * percentOverDue);
    interval = Math.round(interval * (1 + ((difficultyWeight - 1) * percentOverDue)))
  }

  // TODO 여기서 +=1 을 하는데 왜 2가 추가되는거같지...?
  if (globalOnDemandVars.delayOn() && (new Date()).getHours() >= globalOnDemandVars.delayValue()) {
    interval += 1
  }

  return {
    difficulty: difficulty,
    interval: interval,
    dueDate: today + interval,
    update: today
  }
}

// -----------------------------------------------------------------------------------------------------------
// -----------------------------------------------------------------------------------------------------------

export const getInitialRecordProperty = () => {
  const todayNumber = getTodayNumber(true)
  return ({
    difficulty: defaultDifficulty,
    update: todayNumber - 1,
    interval: 1,
    ratingRecord: []
  })
}
// -----------------------------------------------------------------------------------------------------------

// if (process.env.NODE_ENV !== 'production') {
//   let testRecord1 = getInitialRecordProperty()/* ? */
//
//   // testRecord1 = getNewRecord(testRecord1, 0)/*?*/
//   // testRecord1
//   testRecord1 = getNewRecord(testRecord1, EASY)/* ? */
//   testRecord1 = getNewRecord(testRecord1, EASY, 2)/* ? */
//   testRecord1 = getNewRecord(testRecord1, EASY, 2 + 4)/* ? */
//   testRecord1 = getNewRecord(testRecord1, EASY, 2 + 4 + 7)/* ? */
//
//   testRecord1 = getNewRecord(testRecord1, FAIL, 50)/* ? */
//   // testRecord1 = getNewRecord(testRecord1, HARD, 50)/* ? */
//   testRecord1 = getNewRecord(testRecord1, EASY, 50)/* ? */
//   testRecord1 = getNewRecord(testRecord1, EASY, 50)/* ? */
//
//   let testRecord2 = getInitialRecordProperty()
//
//   testRecord2 = getNewRecord(testRecord2, FAIL)/* ? */
//   testRecord2 = getNewRecord(testRecord2, FAIL)/* ? */
//   testRecord2 = getNewRecord(testRecord2, FAIL)/* ? */
//   testRecord2 = getNewRecord(testRecord2, FAIL)/* ? */
//   testRecord2 = getNewRecord(testRecord2, FAIL)/* ? */
//   testRecord2 = getNewRecord(testRecord2, EASY)/* ? */
// }
// -----------------------------------------------------------------------------------------------------------
// -----------------------------------------------------------------------------------------------------------
